// extracted by mini-css-extract-plugin
export var avatarContainer = "_a3-0";
export var avatarTypingWave = "_a3-i";
export var gray = "_a3-f";
export var green = "_a3-c";
export var icon = "_a3-9";
export var image = "_a3-1";
export var lg = "_a3-6";
export var md = "_a3-5";
export var presenceDot = "_a3-b";
export var red = "_a3-d";
export var sm = "_a3-4";
export var status = "_a3-a";
export var typingDot = "_a3-h";
export var typingPill = "_a3-g";
export var xl = "_a3-7";
export var xs = "_a3-3";
export var xxl = "_a3-8";
export var xxs = "_a3-2";
export var yellow = "_a3-e";